import { Controller } from 'stimulus';
import dataLayer from '../helpers/dataLayer';

class ZeroEmissionCheckController extends Controller {
  connect() {
    this.onPercantageGuessInput();
  }

  onEmailInput() {
    const input = this.emailInputTarget.value;
    const blockedDomains = [
      'gmail',
      'yahoo',
      'outlook',
      'hotmail',
      'icloud',
    ];

    const blockedDomain = blockedDomains.filter((domain) => {
      const regexObj = new RegExp(`@${domain}.*$`);

      return regexObj.test(input);
    });

    let errorMessage = '';

    if (blockedDomain.length) {
      errorMessage = 'Gebruik s.v.p. een zakelijk e-mail adres bijv. jouw.naam@bedrijfsnaam.nl.';
    }

    this.emailErrorTarget.innerText = errorMessage;
  }

  onPercantageGuessInput() {
    const input = this.percentageGuessInputTarget.value;

    this.percentageGuessOutputTarget.innerText = input;
  }

  onAddressListFileSelect() {
    const input = this.addressListFileSelectTarget;

    this.addressListFileNameTarget.innerText = input.files.item(0).name;
  }

  // eslint-disable-next-line class-methods-use-this
  onButtonClick(event) {
    const { currentTarget } = event;

    dataLayer.event('Savings Calculator Register Button', 'click', currentTarget.getAttribute('data-plan'));

    return true;
  }
}

ZeroEmissionCheckController.targets = [
  'emailInput',
  'emailError',
  'percentageGuessInput',
  'percentageGuessOutput',
  'addressListFileSelect',
  'addressListFileName',
];

export default ZeroEmissionCheckController;
